import Swiper, { Navigation, Autoplay } from 'swiper';
import $ from "jquery";

export default function Top(){
    Swiper.use([Navigation, Autoplay])
    let hotnews_slider = new Swiper('.js-top-hotnewsSlider', {
        speed: 450,
        spaceBetween: 6,
        loop: true,
        centeredSlides: true,
        autoplay: {
            delay: 5500,
            disableOnInteraction: false,
            pauseOnMouseEnter: true
        },
        slidesPerView: 'auto',
        breakpoints: {
            768: {
                spaceBetween: 25
            },
            1025: {
                spaceBetween: 70
            },
        },
    })
}
window.onload = function() {
    topFvHeight()
}

$(window).resize(function () {
    topFvHeight()
})

export function topFvHeight() {
	let wHeight = $(window).height();
	let hHeight = $('.l-header').height();
	let maxHeight = $('.p-mv').height() + $('.l-header').height(); //header分の高さを加算したもの
    let wWidth = $(window).width();
    $('.p-mv__scroll').addClass('p-mv__showContent');
	if(wHeight <= maxHeight ){
		$('.p-mv__scroll').css({ top :  wHeight - hHeight - 75  }); //windowの高さからheaderとスクロールアニメーションエリア自身の要素の高さを引く
    }else{
        if(wWidth <= 1025){
            $('.p-mv__scroll').css({ top : '62%' });
        }else{
            $('.p-mv__scroll').css({ top : '58%' });
        }
    }
}